//frontend/src/pages/payments/MockDonation.jsx
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DonationComponent from '../../components/payments/DonationComponent';
import MainLayout from '../../layouts/MainLayout';

const MockDonation = () => {
  const authState = useSelector(state => state.authReducer);
  const [showDonationModal, setShowDonationModal] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(null); // State to store the selected Donation amount
  const loggedInUserName = authState.user.name;

  // Function to handle the selection of Donation amount
  const handleAmountSelection = (amount) => {
    setSelectedAmount(amount);
    setShowDonationModal(true); // Open the PaymentComponent modal when amount is selected
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Mock Donation</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
      {!showDonationModal && (
        <div className="flex flex-wrap">
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(100)}>Rs. 21</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(200)}>Rs. 51.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(250)}>Rs. 101.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(500)}>Rs. 151.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(1000)}>Rs. 201.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(5000)}>Rs. 251.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(10000)}>Rs. 501.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(10000)}>Rs. 1001.00</button>  
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(10000)}>Rs. 5001.00</button>
        </div>
        )}
        {showDonationModal && <DonationComponent onClose={() => setShowDonationModal(false)} loggedInUserName={loggedInUserName} selectedAmount={selectedAmount} />}
      </div>
    </MainLayout>
  );
};

export default MockDonation;
